export const adminListJobs = `query adminListJobs {
  adminListJobs{
    jobId
    active
    description
  }
}`;

export const adminGetJob = `query adminGetJob($jobId: ID!) {
  adminGetJob(jobId: $jobId){
    jobId
    active
    description
    parameters
    extraction {
      active
      export
      name
      query
      server
    }
  }
}`;
